export default import.meta.ROLLUP_FILE_URL_cNGdBrF9x6ZR7xg4xEyLLw